import {networkService as network} from '@/services'

export const eventWebinars = {
  getWebinar({page = 1, take = 10, eventId, order = 'ASC'}) {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-webinars/all?order=${order}&page=${page}&take=${take}&eventId=${eventId}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getWebinarIdx(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-webinars/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  createEventWebinar({event, user, status, auditorium, locale = 'en', name, description, link, videoStreamUrl, startDate, endDate}) {
    return new Promise((resolve, reject) => {
      const request = {event, user, status, auditorium, locale, name, description, link, videoStreamUrl, startDate, endDate}
      network.post(`/event-webinars/locale`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateEventWebinar({ id, event, user, status, auditorium,  locale = 'en', name, description, link, videoStreamUrl, startDate, endDate}) {
    return new Promise((resolve, reject) => {
      const request = { id, event, user, status, auditorium, locale, name, description, link, videoStreamUrl, startDate, endDate}
      network.put(`/event-webinars/${id}`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  deleteWebinar(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/event-webinars/${id}`)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}